/**
 * Strategic-allocation display labels — one map for the ADQC section and the Agreements
 * list SAA column / filter (P19(a), 2026-10-10). The money-market and short-term-bond
 * buckets have short labels; SAA buckets show their code (SAA50).
 */
import { ALLOCATION_ORDER } from '../api/aq';

const ALLOC_LABELS: Record<string, string> = { CASH: 'MM', CASH_PLUS: 'MM+', STB: 'STB' };

export const allocLabel = (a: string): string => ALLOC_LABELS[a] ?? a;

/** Filter / select options in conservatism order (most conservative first). */
export const ALLOCATION_OPTIONS = ALLOCATION_ORDER.map((value) => ({ value, label: allocLabel(value) }));
